// modules are defined as an array
// [ module function, map of requires ]
//
// map of requires is short require name -> numeric require
//
// anything defined in a previous bundle is accessed via the
// orig method which is the require for previous bundles

(function (
  modules,
  entry,
  mainEntry,
  parcelRequireName,
  externals,
  distDir,
  publicUrl,
  devServer
) {
  /* eslint-disable no-undef */
  var globalObject =
    typeof globalThis !== 'undefined'
      ? globalThis
      : typeof self !== 'undefined'
      ? self
      : typeof window !== 'undefined'
      ? window
      : typeof global !== 'undefined'
      ? global
      : {};
  /* eslint-enable no-undef */

  // Save the require from previous bundle to this closure if any
  var previousRequire =
    typeof globalObject[parcelRequireName] === 'function' &&
    globalObject[parcelRequireName];

  var importMap = previousRequire.i || {};
  var cache = previousRequire.cache || {};
  // Do not use `require` to prevent Webpack from trying to bundle this call
  var nodeRequire =
    typeof module !== 'undefined' &&
    typeof module.require === 'function' &&
    module.require.bind(module);

  function newRequire(name, jumped) {
    if (!cache[name]) {
      if (!modules[name]) {
        if (externals[name]) {
          return externals[name];
        }
        // if we cannot find the module within our internal map or
        // cache jump to the current global require ie. the last bundle
        // that was added to the page.
        var currentRequire =
          typeof globalObject[parcelRequireName] === 'function' &&
          globalObject[parcelRequireName];
        if (!jumped && currentRequire) {
          return currentRequire(name, true);
        }

        // If there are other bundles on this page the require from the
        // previous one is saved to 'previousRequire'. Repeat this as
        // many times as there are bundles until the module is found or
        // we exhaust the require chain.
        if (previousRequire) {
          return previousRequire(name, true);
        }

        // Try the node require function if it exists.
        if (nodeRequire && typeof name === 'string') {
          return nodeRequire(name);
        }

        var err = new Error("Cannot find module '" + name + "'");
        err.code = 'MODULE_NOT_FOUND';
        throw err;
      }

      localRequire.resolve = resolve;
      localRequire.cache = {};

      var module = (cache[name] = new newRequire.Module(name));

      modules[name][0].call(
        module.exports,
        localRequire,
        module,
        module.exports,
        globalObject
      );
    }

    return cache[name].exports;

    function localRequire(x) {
      var res = localRequire.resolve(x);
      if (res === false) {
        return {};
      }
      // Synthesize a module to follow re-exports.
      if (Array.isArray(res)) {
        var m = {__esModule: true};
        res.forEach(function (v) {
          var key = v[0];
          var id = v[1];
          var exp = v[2] || v[0];
          var x = newRequire(id);
          if (key === '*') {
            Object.keys(x).forEach(function (key) {
              if (
                key === 'default' ||
                key === '__esModule' ||
                Object.prototype.hasOwnProperty.call(m, key)
              ) {
                return;
              }

              Object.defineProperty(m, key, {
                enumerable: true,
                get: function () {
                  return x[key];
                },
              });
            });
          } else if (exp === '*') {
            Object.defineProperty(m, key, {
              enumerable: true,
              value: x,
            });
          } else {
            Object.defineProperty(m, key, {
              enumerable: true,
              get: function () {
                if (exp === 'default') {
                  return x.__esModule ? x.default : x;
                }
                return x[exp];
              },
            });
          }
        });
        return m;
      }
      return newRequire(res);
    }

    function resolve(x) {
      var id = modules[name][1][x];
      return id != null ? id : x;
    }
  }

  function Module(moduleName) {
    this.id = moduleName;
    this.bundle = newRequire;
    this.require = nodeRequire;
    this.exports = {};
  }

  newRequire.isParcelRequire = true;
  newRequire.Module = Module;
  newRequire.modules = modules;
  newRequire.cache = cache;
  newRequire.parent = previousRequire;
  newRequire.distDir = distDir;
  newRequire.publicUrl = publicUrl;
  newRequire.devServer = devServer;
  newRequire.i = importMap;
  newRequire.register = function (id, exports) {
    modules[id] = [
      function (require, module) {
        module.exports = exports;
      },
      {},
    ];
  };

  // Only insert newRequire.load when it is actually used.
  // The code in this file is linted against ES5, so dynamic import is not allowed.
  // INSERT_LOAD_HERE

  Object.defineProperty(newRequire, 'root', {
    get: function () {
      return globalObject[parcelRequireName];
    },
  });

  globalObject[parcelRequireName] = newRequire;

  for (var i = 0; i < entry.length; i++) {
    newRequire(entry[i]);
  }

  if (mainEntry) {
    // Expose entry point to Node, AMD or browser globals
    // Based on https://github.com/ForbesLindesay/umd/blob/master/template.js
    var mainExports = newRequire(mainEntry);

    // CommonJS
    if (typeof exports === 'object' && typeof module !== 'undefined') {
      module.exports = mainExports;

      // RequireJS
    } else if (typeof define === 'function' && define.amd) {
      define(function () {
        return mainExports;
      });
    }
  }
})({"lr9Jy":[function(require,module,exports,__globalThis) {
function getNestedChildHref(node, force_single_loop = false) {
    if (!node.hasChildNodes()) return [];
    const result = [];
    for(let i = 0; i < node.children.length; i++){
        const child = node.children[i];
        if (child.tagName === "A") {
            result.push(child);
            continue;
        }
        result.push(...getNestedChildHref(child));
    }
    return result;
}
const classes_to_add = [
    "!text-opacity-100",
    "!text-white"
];
window.onload = async ()=>{
    const table_of_contents = document.getElementById("table-of-contents");
    const toc_elements = getNestedChildHref(table_of_contents);
    const root_elements = [
        ...document.querySelectorAll(".is-top")?.values() ?? []
    ];
    const anchors = toc_elements.map((val)=>document.getElementById(val.href.split("#")[1]));
    const root_anchors = root_elements.map((val)=>document.getElementById(val.href.split("#")[1]));
    window.addEventListener("click", function(e) {
        var target = e.target;
        if (target instanceof Element) {
            if (!target.id.endsWith("-collapser")) return;
            target.children[0].classList.toggle("-rotate-90");
            const all = document.querySelectorAll(`[parent-id="${target.id}"]`);
            all.forEach((val)=>val.classList.toggle("hidden"));
        }
    }, false);
    window.addEventListener("scroll", (event)=>{
        highlightTOCElements(toc_elements, anchors);
        highlightTOCElements(root_elements, root_anchors);
    });
};
function highlightTOCElements(elements, anchors) {
    let scrollTop = window.scrollY;
    // highlight the last scrolled-to: set everything inactive first
    elements.forEach((link, index)=>{
        for (const class_name of classes_to_add)link.classList.remove(class_name);
    });
    // then iterate backwards, on the first match highlight it and break
    let found_element = null;
    for(var i = anchors.length - 1; i >= 0; i--)if (scrollTop > anchors[i].offsetTop - 10) {
        found_element = elements[i];
        break;
    }
    const highlighted_element = found_element ?? elements[0];
    const elements_to_highlight = [
        highlighted_element,
        ...elements.filter((val)=>val.href === highlighted_element.href)
    ];
    // Because there is a hidden TOC, we need to highlight all elements that match
    for (const element of elements_to_highlight)for (const class_name of classes_to_add)element.classList.add(class_name);
}

},{}]},["lr9Jy"], "lr9Jy", "parcelRequire7ff5", {})

//# sourceMappingURL=manual.02976dbf.js.map
